import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import 'leaflet/dist/leaflet.css';
import { UserProvider } from './contexts/user';
import { CartProvider } from './contexts/cart';
import { SearchProvider } from './contexts/search';
import { SignupInviteProvider } from './contexts/buyer-invite';
import { FilterConfigProvider } from './contexts/filters';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <UserProvider>
    <CartProvider>
      <SearchProvider>
        <SignupInviteProvider>
          <FilterConfigProvider>
            <App />
          </FilterConfigProvider>
        </SignupInviteProvider>
      </SearchProvider>
    </CartProvider>
  </UserProvider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
